export default __webpack_public_path__ + "static/media/Avery-Trufellman.61bfc87e.jpg";